export function mapAndSort<TItem, TMappedItem extends Record<string, any>>(
  arr: TItem[] | undefined,
  mapfunc: (item: TItem) => TMappedItem,
  sortby: string
) {
  if (arr === undefined) {
    return undefined
  }
  const output = arr.map(mapfunc)
  output.sort((a: TMappedItem, b: TMappedItem) => {
    if (a[sortby] > b[sortby]) {
      return -1
    } else if (b[sortby] < a[sortby]) {
      return 1
    } else {
      return 0
    }
  })
  return output
}
